<template>
  <div>
    <div class="soft-cantainer">
      <div class="soft-main">
        <div class="soft-header">
          <h2>软件下载</h2>
          <p>2024-04-10 09:51:51</p>
        </div>
        <div class="search-box">
          <div class="search-box-left">
            <div class="search-item">
              <el-input size="mini" placeholder="供应商" prefix-icon="el-icon-search" v-model="queryParams.supName"
                clearable @input="querySearch" />
            </div>
            <div class="search-item">
              <el-input size="mini" placeholder="文件名称" prefix-icon="el-icon-search" v-model="queryParams.fileName"
                clearable @input="querySearch" />
            </div>
            <div class="search-item">
              <el-select size="mini" v-model="queryParams.softApp" placeholder="适用软件" @change="querySearch">
                <el-option class="option-item" v-for="item in softList" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-input size="mini" placeholder="种植体品牌" prefix-icon="el-icon-search" v-model="queryParams.implSys"
                clearable @input="querySearch" />
            </div>
            <div class="search-item">
              <el-input size="mini" placeholder="种植体型号" prefix-icon="el-icon-search" v-model="queryParams.implModel"
                clearable @input="querySearch" />
            </div>
          </div>
          <div class="search-box-right">
            <!-- <y-button text="上传" classStyle="main-btn ml" @btnClick="openAdd"></y-button> -->
            <y-button text="搜索" classStyle="main-btn ml" @btnClick="querySearch"></y-button>
            <y-button text="重置" classStyle="main-btn ml" @btnClick="resetSearch"></y-button>
          </div>
        </div>
        <el-tabs v-model="activeTab" @tab-click="changeTab"
        style="margin:-15px 0 -10px 20px;width: 97%;">
          <el-tab-pane label="全部数据" name="all">
          </el-tab-pane>
          <!-- <el-tab-pane label="我的上传" name="mine">
          </el-tab-pane> -->
        </el-tabs>

        <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
          style="height: calc(100vh - 258px);">

          <div class="table-wrap" style="height: calc(100vh - 238px);">
            <el-table ref="multipleTable" :data="dataList" :row-class-name="tabRowClass"
              style="width: 100%;font-size: 13px;" size="small" :stripe="true" border
              @selection-change="handleSelectionChange" v-if="dataList.length > 0">
              <el-table-column type="selection" width="40"></el-table-column>

              <el-table-column header-align="center" align="center" label="供应商" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.supName }}
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="文件名称" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.fileName }}
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="适用软件" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="val in softList" v-if="scope.row.softApp == val.value">{{ val.label }}</span>
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="种植体品牌" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.implSys }}
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="种植体型号" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.implModel }}
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" label="进度状态" show-overflow-tooltip v-if="activeTab=='mine'">
                <template #default="scope">
                  <span v-if="scope.row.delFlag=='0'">已发布</span>
                  <span v-if="scope.row.delFlag=='2'">审核中</span>
                  <span v-if="scope.row.delFlag=='3'">
                    <span style="color: red;">已驳回</span>
                    ,{{ scope.row.remark }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center">
                <template #default="scope">
                  <a class="operate" @click="downFile(scope.row)">下载</a>
                  <span v-if="activeTab=='mine'">|</span>
                  <!-- <a class="operate" @click="editRow(scope.row)" v-if="activeTab=='mine'">修改</a>
                  <span v-if="activeTab=='mine'">|</span> -->
                  <a class="operate" @click="removeRow(scope.row)" v-if="activeTab=='mine'">删除</a>
                </template>
              </el-table-column>
            </el-table>
            <div class="no-data" v-if="noData">
              暂无数据
            </div>
            <div class="pagination-wrap" v-if="dataList.length">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
                :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        <el-dialog center :title="title" width="30%" :visible.sync="fileDialog" :modal-append-to-body="false"
          :destroy-on-close="true" :lock-scroll="false">
          <el-form :model="ruleForm" ref="ruleForm" style="margin-top: -10px;">
            <div class="input-upload-wrap" style="height: 450px;">
              <el-form-item>
                <div class="impl-left">
                  <el-form-item prop="supName" label="供应商名称:" label-width="100px">
                    <el-input v-model="form.supName" placeholder="请输入供应商名称" size="small" />
                  </el-form-item>
                </div>
                <div class="impl-left" style="margin-bottom: 5px;">
                  <el-form-item label="文件名称:" label-width="100px">
                    <el-input v-model="form.fileName" placeholder="上传文件后填充" size="small" readonly />
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="文件上传:" style="margin-left: 25px;">
                <el-upload ref="upload" action :http-request="uploadFile"
                  :data="{objectType:'25',objectTag:'soft_file'}" :limit="1" :on-exceed="handleExceed"
                  :on-remove="(file, fileList) => { handleRemove(file, fileList, '25') }"
                  :file-list="fileList" :auto-upload="true">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" style="margin-left: 70px;">
                    请上传 大小不超过
                    <b style="color: #f56c6c">{{ fileSize }}</b>
                    格式为
                    <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
                    的文件
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px;">
                <div class="impl-left">
                  <el-form-item label="文件排序:" label-width="100px">
                    <el-input-number v-model="form.sort" controls-position="right" :min="0" size="small" disabled />
                  </el-form-item>
                  <el-form-item prop="implSysId" label="植体品牌:" label-width="100px" style="margin: 10px auto;">
                    <el-select class="distance" v-model="form.implSysId" filterable placeholder="请选择植体品牌" size="small"
                      @change="changeImplSys(form.implSysId)" v-if="title=='新增数据'">
                      <el-option v-for="item in implList" :key="item.implId" :label="item.implName"
                        :value="item.implId" />
                    </el-select>
                    <el-input v-model="form.implModel" placeholder="请输入植体型号" size="small" v-else/>
                  </el-form-item>
                  <el-form-item label="植体品牌:" label-width="100px" v-if="form.implSysId=='1099'">
                    <el-input v-model="form.otherImplSys" placeholder="请输入植体品牌" size="small" />
                  </el-form-item>
                </div>
                <div class="impl-left">
                  <el-form-item prop="softApp" label="适用软件:" label-width="100px">
                    <el-select class="distance" v-model="form.softApp" filterable placeholder="请选择" size="small">
                      <el-option v-for="item in softList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="implModelId" label="植体型号:" label-width="100px" style="margin: 10px auto;">
                    <el-select class="distance" v-model="form.implModelId" filterable placeholder="请选择" size="small" v-if="title=='新增数据'">
                      <el-option v-for="item in implModelList" :key="item.implId" :label="item.implName"
                        :value="item.implId" />
                    </el-select>
                    <el-input v-model="form.implModel" placeholder="请输入植体型号" size="small" v-else/>
                  </el-form-item>
                  <el-form-item label="植体型号:" label-width="100px" v-if="form.implSysId=='1099'">
                    <el-input v-model="form.otherImplModel" placeholder="请输入植体型号" size="small" />
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="备注信息:" label-width="100px">
                <el-input v-model="form.remark" type="textarea" placeholder="留言至管理员" />
              </el-form-item>
              <div slot="footer" class="dialog-footer" style="margin-left:68%;">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="fileDialog = false">取 消</el-button>
              </div>
            </div>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import YButton from '/components/YButton'
import SButton from '/components/SButton'
import BaseTag from '/components/BaseTag'
import { Loading } from 'element-ui';
import { mapState } from 'vuex';
import { parseTime } from '@/utils/utils';
import {
  uploadByPieces
} from "../../../common/upload.js";
import graceChecker from '../../../common/graceChecker.js';
export default {
  data() {
    return {
      loading: true,
      noData: false,
      dataList: [],
      fileList: [],
      total: 0,
      softList: [
        {
          label: '3shape',
          value: '01'
        },
        {
          label: 'exocad',
          value: '02'
        },
        {
          label: 'inlab',
          value: '03'
        },
        {
          label: 'cerec',
          value: '04'
        }
      ],
      fileDialog: false,
      title:'',
      dataFile:[],
      implList: [],
      implModelList: [],
      fileSize:'500M',
      activeTab:'all',
      fileType:['dme','zip','dcm'],
      form:{
        supName: '',
        fileName: '',
        filePath:'',
        implSys: '',
        implModel: '',
        softApp: '',
        implSysId: '',
        implModelId: '',
        otherImplSys: '',
        otherImplModel: '',
        sort:'',
        remark: '',
      },
      ruleForm:{

      },
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        supName: '',
        fileName: '',
        implSys: '',
        implModel: '',
        softApp: '',
        createBy:'',
        delFlag: '0',
      },
    }
  },
  computed: {
    ...mapState(['common', 'user']),
  },
  methods: {
    getParamsInfo() {
      this.loading = true
      this.$api.get({
        url: '/biz/softDown/list',
        data: this.queryParams
      }).then(res => {
        this.dataList = res.rows;
        this.loading = false;
        this.noData = false;
        this.total = res.total;
      })
    },
    downFile(row) {
      let url = row.filePath;
      const loading = Loading.service({
        lock: true,
        text: '正在下载，已下载 0%',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100;
          loading.setText('正在下载，已下载' + percentComplete.toFixed(2) + '%')
          if (percentComplete == 100) {
            loading.close();
          }
          // 更新你的加载指示器
        }
      }
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = row.fileName;
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blobUrl);
        }
      }
      xhr.onerror = function () {
        console.error('Error downloading the file.');
        // 处理错误，隐藏或重置加载指示器
      }
      xhr.send();
    },
    editRow(row){
      this.reset();
      this.fileList = [];
      this.title = '修改数据';
      this.form = row;
      this.fileDialog = true;
      this.fileList.push({ name: this.form.fileName, url: this.form.filePath });
    },
    removeRow(row){
      this.$api.post({
        url: '/biz/softDown/remove/'+row.id,
      }).then(res => {
        if(res.code=='200'){
          this.$yxz.msg('删除成功', 'success');
        }else{
          this.$yxz.msg(res.msg, 'error');
        }
        this.reset();
        this.getParamsInfo();
      })
    },
    tabRowClass({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'tabRow';
      }
    },
    querySearch() {
      if(this.activeTab=='all'){
        this.queryParams.createBy = '';
      }else if(this.activeTab=='mine'){
        this.queryParams.createBy = this.user.userId;
      }
      this.getParamsInfo();
    },
    reset(){
      this.form = {
        supName: '',
        fileName: '',
        filePath:'',
        implSys: '',
        implModel: '',
        softApp: '',
        implSysId: '',
        implModelId: '',
        otherImplSys: '',
        otherImplModel: '',
        sort:'',
        remark: '',
      };
    },
    resetSearch() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 15,
        supName: '',
        fileName: '',
        softApp: '',
        implSys: '',
        implModel: '',
        createBy:'',
        delFlag: this.queryParams.delFlag,
      }
      if(this.activeTab=='all'){
        this.queryParams.createBy = '';
      }else if(this.activeTab=='mine'){
        this.queryParams.createBy = this.user.userId;
      }
      this.querySearch();
    },
    openAdd(){
      this.reset();
      this.title = '新增数据';
      this.implList = this.common.implList;
      this.fileDialog = true;
    },
    changeImplSys(id) {
      this.implModelList = [];
      this.implModelList = this.common.implDict.get(id).children;
      if (id == '1099') {
        this.form.implModelId = '109901';
        this.form.implModel = '其他';
      }
    },
    checkValid(){
      var rule = [
        {
          name:'supName',
          checkType:'notNull',
          errorMsg: '请输入供应商名称',
          isValid: '1'
        },
        {
          name: 'softApp',
          checkType:'notNull',
          errorMsg: '请选择适用软件',
          isValid: '1'
        },
        {
          name: 'implSysId',
          checkType:'notNull',
          errorMsg: '请选择植体系统',
          isValid: this.title=='新增数据'?'1':'0'
        },
        {
          name: 'implModelId',
          checkType:'notNull',
          errorMsg: '请选择植体型号',
          isValid: this.title=='新增数据'?'1':'0'
        },
        {
          name: 'filePath',
          checkType:'notNull',
          errorMsg: '请上传文件',
          isValid: '1'
        },
      ]
      var tempRule = rule.filter(item=>{
        return item.isValid == '1'
      })
      var formData = {
        supName: this.form.supName,
        softApp: this.form.softApp,
        implSysId: this.form.implSysId,
        implModelId: this.form.implModelId,
        filePath:this.form.filePath
      }
      var checkRes = graceChecker.check(formData, tempRule);
      if (!checkRes) {
        this.$yxz.msg(graceChecker.error);
        return false
      }else{
        return true
      }
    },
    submitForm(){
      if(!this.checkValid()){
        return false
      }
      if (!this.form.id) {
        // 当选择植体信息选择其他时，把填写的其他信息赋值给implSysId和implModelId
        this.form.implSys = this.form.implSysId == '1099' ? this.form.otherImplSys : this.common.implDict.get(this.form.implSysId).implName;
        this.form.implModel = this.form.implModelId == '109901' ? this.form.otherImplModel : this.common.implDict.get(this.form.implModelId).implName;
      }
      var orderData = {
        supName: this.form.supName,
        fileName: this.form.fileName,
        filePath: this.form.filePath,
        implSys: this.form.implSys,
        implModel: this.form.implModel,
        sort: this.form.sort,
        softApp: this.form.softApp,
        remark: this.form.remark,
        createBy:this.user.userId,
        createTime: parseTime(new Date()),
        updateBy:this.user.userId,
        updateTime: parseTime(new Date()),
        delFlag:'2',
      }
      let url = this.form.id?'/biz/softDown/edit':'/biz/softDown/add';
      orderData.id = this.form.id?this.form.id:'';
      this.$api.post({
        url: url,
        data: orderData
      }).then(res => {
        if (res.code == 200) {
          this.$yxz.msg('已提交至后台审核', 'success');
        } else {
          this.$yxz.msg(res.msg);
        }
        this.reset();
        this.fileList = [];
        this.getParamsInfo();
        this.fileDialog = false;
      })
    },
    async uploadFile(options) {
      const { file, data } = options
      var loading = this.$loading({
        text: '等待上传完成，已上传 0%'
      })
      uploadByPieces({
        file: file, // 文件
        data: data,
        pieceSize: 3, // 分片大小
        concurrent: 3,
        process: res => {
          loading.setText('等待上传完成，已上传' + res + '%')
          console.log('分片上传 -> process', res)
          // if (res === 100) {
          //   loading.close()
          // }
        },
        success: res => {
          console.log('分片上传 -> success', res)
          this.form.fileName = file.name
          this.form.filePath = res.data.url;
          this.fileList.push({ name: file.name, url: res.data.url })
          console.log('file:',this.fileList)
          this.$nextTick(()=>{
            loading.close()
          })
        },
        error: e => {
          this.$yxz.msg('网络错误: ' + e, 'error')
          console.log('分片上传 -> error', e)
        }
      })
    },
    handleChange(){
      return true
    },
    beforeRemove(){

    },
    handleExceed(){
      this.$message({
        type: 'error',
        message: '最多支持1个文件上传，上传多个文件请打包上传'
      })
    },
    handleSelectionChange() {
      // 选中多文件下载
    },
    handleCurrentChange() {
      //切换页码
      this.getParamsInfo()
    },
    handleRemove(file, fileList, type){
      let tempData = this.fileList;
      if (tempData == '') {
        this.$message("数据错误！！")
        return false
      }
      tempData.splice(0, 1);
      this.$message({
        type: 'success',
        message: '移除成功!'
      });
    },
    handlePreview(){

    },
    changeTab(){
      this.resetSearch();
      let val = this.activeTab;
      switch(val){
        case 'all':
          this.queryParams.delFlag = '0';
          this.getParamsInfo();
          break;
        case 'mine':
          this.queryParams.createBy = this.user.userId;
          this.queryParams.delFlag = null;
          this.getParamsInfo();
          break;
      }
    }
  },
  created() {
    this.getParamsInfo()
  },
  components: {
    YButton,
    SButton,
    BaseTag
  }
}
</script>
<style scoped>
.soft-cantainer {
  width: 100%;
  height: auto;
}

.soft-header {
  width: 100%;
  height: 130px;

  h2 {
    font-size: 30px;
    line-height: 130px;
    text-align: center;
  }

  h2+p {
    color: #ccc;
    text-align: center;
    margin-top: -30px;
  }
}

.soft-main {
  width: 64%;
  height: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
  border-radius: 5px;
  background-color: white;
}

.search-box {
  overflow: hidden;
  position: relative;
  margin: 10px;
  padding: 10px;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #626262;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 10;

  .search-box-left {
    display: flex;
    flex-direction: row;
  }

  .search-item {
    margin-right: 10px;

    &.mt {
      margin-top: 1px;
    }
  }

  .search-box-right {
    display: flex;
    flex-direction: row;
  }

}

.option-item {
  display: list-item !important;
}

.order-list {
  border-radius: 8px;
  position: relative;
  z-index: 20;
  background: #f7f7f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.table-wrap {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}

.pagination-wrap {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 5px 15px;
}

.impl-left{
  width: 50%;
  height: auto;
  float: left;
}
.distance{
  width: 159px;
}
.operate{
  margin: 0 5px;
  color: #606266;
}
.operate:hover{
  color: #70a1ff;
}
</style>
<style type="text/css">
.tabRow {
  background-color: #CED0DC !important;
}
</style>



// WEBPACK FOOTER //
// software.vue?182f08b8